
import Promise from 'bluebird';
import type { FilterObject, FilterStorageOptions, PreferenceService } from './types';

export class PermanentFilterStorage {
  featureName: string;
  isAccountLevel: boolean;
  storage: PreferenceService;
  storageKey: string;

  /**
   * Filter storage based on preference service
   */

  constructor({
    featureName = '',
    preferenceService,
    storageKey,
    isAccountLevel = false,
  }: FilterStorageOptions = {}) {
    if (!preferenceService) {
      throw new Error('No preference service is provided');
    }

    if (storageKey) {
      this.storageKey = storageKey;
    } else {
      this.storageKey = this.getStorageKey(featureName);
    }

    this.featureName = featureName;
    this.storage = preferenceService;
    this.isAccountLevel = isAccountLevel;
  }

  // eslint-disable-next-line no-unused-vars
  getStorageKey(featureName?: string): string {
    throw new Error('Not implemented');
  }

  save(filter: FilterObject | string) {
    const preferenceData = {
      Name: this.storageKey,
      Data: filter,
    };
    if (this.isAccountLevel) {
      return this.storage.setAtAccountLevel(preferenceData);
    }
    return this.storage.setAtUserLevel(preferenceData);
  }

  get(): Promise<FilterObject> {
    return Promise.resolve(this.isAccountLevel ?
      this.storage.findByNameAtAccountLevel(this.storageKey)
      : this.storage.findByNameAtUserLevel(this.storageKey))
      .then(result => (result ? { filter: result.Data } : { query: null as null }));
  }

  getFilterInSync(): { filter: any } | null {
    const result = this.isAccountLevel ?
      this.storage.findByNameAtAccountLevel(this.storageKey)
      : this.storage.findByNameAtUserLevel(this.storageKey);
    return result ? { filter: result.Data } : null;
  }

  delete() {
    const result = this.isAccountLevel ?
      this.storage.findByNameAtAccountLevel(this.storageKey)
      : this.storage.findByNameAtUserLevel(this.storageKey);
    if (result && result.Id) {
      return this.isAccountLevel ? this.storage.del(result.Id) :
        this.storage.delAtUserLevel(result.Id);
    }
    return null;
  }
}
